var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import axios from "axios";
import * as StorageHelpers from "../../helpers/storage";
import config from "../../assests/config";
import { ShareRequestTableHeaders, SubShareRequestTableHeaders, UHF_BRAND, } from "./MyShareRequestTable/data";
import apiService from "../../helpers/apiService";
const formatDateMonth = new Intl.DateTimeFormat("en-US", { dateStyle: "full" });
const getEmployeeIdToken = ({ appConfig, mode }) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const requestURL = config.API_URLS[`${appConfig.brand.toUpperCase()}_MYNEEDS_${mode.toUpperCase()}`] + "/login/";
        const data = config.credentials.getEmployeeIdApi[mode];
        const requestData = {
            username: data.username,
            password: data.password,
        };
        const { data: tokenResponse } = (yield axios.post(requestURL, requestData, {
            headers: {
                "Content-type": "application/json",
                "x-api-key": data.xApiKey,
            },
        })) || {};
        return tokenResponse.data.id_token;
    }
    catch (error) {
        console.log("getEmployeeIdToken ERROR: ", error);
        return error;
    }
});
export const getEmployeeId = ({ appConfig, mode }) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const token = yield getEmployeeIdToken({ appConfig, mode });
        const requestURL = config.API_URLS[`${appConfig.brand.toUpperCase()}_MYNEEDS_${mode.toUpperCase()}`];
        const data = config.credentials.getEmployeeIdApi[mode];
        const requestData = {
            URL: requestURL +
                "/member-report?report-type=getEmpi&email=" +
                StorageHelpers.getLocalStorage("userMail"),
            headers: {
                "x-api-key": data.xApiKey,
                token,
            },
        };
        const { data: getEmployeeIdResponse } = (yield axios.get(requestData.URL, {
            headers: {
                "Content-type": "application/json",
                "x-api-key": data.xApiKey,
                token: token,
            },
        })) || {};
        StorageHelpers.setLocalStorage("EMPID", (getEmployeeIdResponse === null || getEmployeeIdResponse === void 0 ? void 0 : getEmployeeIdResponse[0].empi) || "");
        return getEmployeeIdResponse;
    }
    catch (error) {
        console.log("getEmployeeId ERROR: ", error);
        return error;
    }
});
export const getMyneedsEOSForNetwell = ({ appConfig, mode, }) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const envDetails = config.credentials.NETWELL_MY_NEEDS_EOS[mode || "dev"];
        let requestData = {
            // Default for NETWELL
            username: envDetails.username,
            password: envDetails.password,
        };
        if (appConfig.brand.toLowerCase() !== config.netwell) {
            const data = config.credentials.getEmployeeIdApi[mode || "dev"];
            requestData = {
                username: data.username,
                password: data.password,
            };
        }
        const { data: netwellMyNeedsEosResponse } = yield axios.post(envDetails.getToken, {}, {
            auth: requestData,
            headers: { "Content-Type": "application/x-www-form-urlencoded" },
        });
        // 2nd API
        const myNeedsDataForEmployeeURL = envDetails.eosEmployeeURL +
            (localStorage.getItem("Member_EMPID")); // testing id 444228937
        const { data: netwellMyNeedsEosEmployeeResponse } = yield axios.get(myNeedsDataForEmployeeURL, {
            headers: {
                "x-api-key": envDetails.xAPIKey,
                token: netwellMyNeedsEosResponse.access_token,
            },
        });
        const requiredResponse = netwellMyNeedsEosEmployeeResponse.map((data) => {
            return Object.keys(ShareRequestTableHeaders).reduce((acc, key) => {
                let modifiedData = data[key];
                if (key === "service_date") {
                    modifiedData = formatDateMonth.format(new Date(modifiedData));
                    const findIndex = modifiedData.indexOf(",");
                    modifiedData = modifiedData.slice(findIndex + 2);
                }
                else if (key === "charged_amount") {
                    modifiedData = modifiedData ? `$${modifiedData}` : "";
                }
                else if (key === "paid_amount") {
                    modifiedData = modifiedData ? `$${modifiedData}` : "";
                }
                else if (key === "mpv") {
                    modifiedData = modifiedData ? `$${modifiedData}` : "";
                }
                else if (key === "mcp") {
                    modifiedData = modifiedData ? `$${modifiedData}` : "";
                }
                else if (key === "shareable_amount") {
                    modifiedData = modifiedData ? `$${modifiedData}` : "";
                }
                else if (key === "status") {
                    modifiedData = ["Paid", "Denied", "Issued"].includes(modifiedData)
                        ? "FINAL"
                        : "IN REVIEW";
                }
                return Object.assign(Object.assign({}, acc), { memberName: `${data.first_name} ${data.last_name}`, [key]: modifiedData || "$0", data });
            }, {});
        });
        return modifySubTableData(requiredResponse);
    }
    catch (error) {
        return error;
    }
});
export const modifySubTableData = (requiredData) => {
    return requiredData.map((data, index) => {
        return Object.keys(SubShareRequestTableHeaders).reduce((acc, key) => {
            let modifiedData = data.data[key];
            console.log(modifiedData, key, index);
            if (key === "mpv") {
                modifiedData = modifiedData ? `$${modifiedData}` : "";
            }
            else if (key === "mcp") {
                modifiedData = modifiedData ? `$${modifiedData}` : "";
            }
            else if (key === "shareable_amount") {
                modifiedData = modifiedData ? `$${modifiedData}` : "";
            }
            else if (key === "repricing_amount") {
                modifiedData = modifiedData ? `$${modifiedData}` : "";
            }
            else if (key === "date_paid" && modifiedData !== "0000-00-00") {
                modifiedData = formatDateMonth
                    .format(new Date(modifiedData))
                    .split(",")
                    .slice(1);
            }
            return Object.assign(Object.assign(Object.assign({}, acc), data), { [key]: modifiedData });
        }, {});
    });
};
export const openUrl = (id) => __awaiter(void 0, void 0, void 0, function* () {
    const requestData = {
        username: "13o89ebh8v09h57uq29ue5on7g",
        password: "6ncg3ckkb9bogia75h93ehqi8d9id15ppg5dn73e5shs0h3cq0f",
    };
    const { data: openUrlResponse } = yield axios.post("https://netwelldevshareplus.auth.us-east-2.amazoncognito.com/oauth2/token?grant_type=client_credentials&client_id=13o89ebh8v09h57uq29ue5on7g&scope=apiauthidentifier/member.read", {}, {
        auth: requestData,
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
    });
    const { data: openUrlResponseWithToken } = yield axios.get(`https://klbv8hqfgl.execute-api.us-east-2.amazonaws.com/v0/member-report/eos?search-string=${id}&bucket=eos-devenv`, {
        auth: requestData,
        headers: {
            "x-api-key": "lIIwjqkmZF3V5T2Mk8qYG3aUStltuWQAaPkpq9JL",
            token: openUrlResponse.access_token,
        },
    });
    return (openUrlResponseWithToken.length &&
        Object.keys(openUrlResponseWithToken[0]).map((k) => openUrlResponseWithToken[0][k])[0]);
});
export const setOpenpopups = (billkey) => __awaiter(void 0, void 0, void 0, function* () {
    var _a;
    let requestData = {
        username: "7s7nub5kqc537lojb7v3p6pcib",
        password: "1539f1301c4cji9cppagdeo3a1qgnqfmt14ocu6gqsturnf94rd4",
    };
    const { data: setOpenpopupsResponse } = yield axios.post("https://prodnetwell.auth.us-east-2.amazoncognito.com/oauth2/token?grant_type=client_credentials&client_id=7s7nub5kqc537lojb7v3p6pcib&scope=apiauthidentifier/member.read", {}, {
        auth: requestData,
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
    });
    const { data: setOpenpopupsWithTokemResponse } = yield axios.get(`https://klazjadjh1.execute-api.us-east-2.amazonaws.com/v0/member-report/contributors?need-id=${billkey}`, {
        headers: {
            "x-api-key": "fylhvz5mOP1FroRvrVkiz1Q8YzW5KTmYaR8mf2Sv",
            token: setOpenpopupsResponse.access_token,
        },
    });
    return {
        data: (_a = setOpenpopupsWithTokemResponse.contributors) === null || _a === void 0 ? void 0 : _a.map((data) => ({
            name: [data.first_name, data.last_name].map((name) => name[0]),
            amount: data.contribution_amount,
        })),
        totalContributorn: setOpenpopupsWithTokemResponse.total_contributions,
        message: "",
    };
});
export const getMyneedsEOS_UHF = ({ mode }) => __awaiter(void 0, void 0, void 0, function* () {
    //uses username and password to log into the API
    const envDetails = config.credentials.UHF_MY_NEEDS_EOS[mode || "dev"];
    const request = {
        username: envDetails.username,
        password: envDetails.password
    };
    const sharePlusLogin_Request = {
        URL: envDetails.baseURL + config.credentials.UHF_MY_NEEDS_EOS.sharePlusLogin,
        data: request,
        brand: config.uhf,
        headers: {
            'Content-type': 'application/json',
            'x-api-key': envDetails.xAPIKey
        }
    };
    let subscriberNeeds_Request = envDetails.baseURL + config.credentials.UHF_MY_NEEDS_EOS.subcriberNeeds;
    try {
        const { data: sharePlusLogin_Reponse } = yield apiService.post(sharePlusLogin_Request);
        const token = sharePlusLogin_Reponse.data.id_token;
        const id = StorageHelpers.getLocalStorage("EMPID") || "608452";
        const { data: subscriberNeeds_Reponse } = yield axios.get(subscriberNeeds_Request + id, {
            headers: {
                'x-api-key': envDetails.xAPIKey,
                token
            }
        });
        const requiredResponse = subscriberNeeds_Reponse.map((data) => {
            return [...UHF_BRAND.headCells.map(({ id }) => id), ...Object.keys(UHF_BRAND.SubShareRequestTableHeaders)].reduce((acc, key) => {
                let modifiedData = data[key];
                console.log(modifiedData, key);
                if (key === "service_date") {
                    modifiedData = formatDateMonth.format(new Date(modifiedData));
                    const findIndex = modifiedData.indexOf(",");
                    modifiedData = modifiedData.slice(findIndex + 2);
                }
                else if (["sharing_percentage", "eligible_for_sharing", "repricing_amount", "consultation_fee", "member_responsibility", "charged_amount", "ineligible_amount"].includes(key)) {
                    modifiedData = modifiedData ? `$${modifiedData}` : "$0";
                }
                else if (key === "memberName") {
                    modifiedData = data.first_name + " " + data.last_name;
                    console.log("key Inside: ", key, data, modifiedData);
                }
                return Object.assign(Object.assign({}, acc), { memberName: `${data.first_name} ${data.last_name}`, [key]: modifiedData || "NA", data });
            }, {});
        });
        console.log("requiredResponse:: ", requiredResponse);
        return requiredResponse;
    }
    catch (error) {
        return error;
    }
});
